import type { RefObject } from 'react';
// import { fadeTo } from 'util/animation/fade/fade';

interface ServicePowersRefs {
  elementRef?: RefObject<HTMLElement | null>;
}

export function setupTransitionInTimeline(
  timeline: gsap.core.Timeline,
  { elementRef }: ServicePowersRefs,
): void {
  if (elementRef?.current) {
    timeline.fromTo(elementRef.current, {}, {});
  }
}
//
// export function setupTransitionOutTimeline(
//   timeline: gsap.core.Timeline,
//   { elementRef }: ServicePowersRefs,
// ): void {
//   if(elementRef?.current) {
//     timeline.add(fadeTo(elementRef.current as HTMLElement));
//   }
// }
